/**
 * 조회 조건 기억하기
 * ---------------------------------------------------------------------------
 * 상세 화면에서 저장하거나 지우고 목록으로 돌아오면, 보고 있던 조건이 그대로여야
 * 한다. 사업장을 고르고 기간을 3월로 맞춰 둔 사람이 한 건 고치고 돌아왔을 때
 * 다시 "이번 달 · 전체 사업장" 이면, 같은 조작을 하루에 수십 번 반복하게 된다.
 *
 * 왜 sessionStorage 인가
 *   localStorage 면 한 달 전에 보던 조건이 오늘 아침에도 남아 있다. 어제 3월을
 *   보다 껐는데 오늘 열었더니 3월이면 그게 더 혼란스럽다.
 *   sessionStorage 는 탭을 닫으면 사라진다. "이번 작업 중에는 기억, 새로 열면
 *   처음부터" 가 사람의 기대에 맞는다.
 *
 * 왜 주소(쿼리스트링)가 아닌가
 *   주소에 담으면 뒤로가기와 북마크가 되어 더 낫다. 다만 지금 목록과 상세가
 *   주소를 주고받는 구조가 아니어서, 그렇게 바꾸려면 두 화면의 이동 경로를 전부
 *   손봐야 한다. 기억하는 것이 목적이므로 작은 쪽을 골랐다.
 *
 * 저장에 실패해도 조용히 넘어간다
 *   사생활 보호 모드나 저장 공간이 꽉 찬 브라우저에서는 접근 자체가 예외를
 *   던진다. 조회 조건을 기억하지 못하는 것은 불편이지, 화면이 멈출 일이 아니다.
 */

const PREFIX = 'eco.filter.';

export function loadFilter<T>(key: string): Partial<T> | null {
  try {
    const raw = sessionStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    // 저장 형식이 바뀐 뒤 옛 값이 남아 있을 수 있다. 객체가 아니면 버린다.
    if (typeof parsed !== 'object' || parsed === null) return null;
    return parsed as Partial<T>;
  } catch {
    return null;
  }
}

export function saveFilter(key: string, value: unknown): void {
  try {
    sessionStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    // 저장 못 해도 화면은 그대로 돈다.
  }
}
